import type { BrowserSafeConfig } from './config-shared'

export default (typeof window === 'undefined'
    ? {}
    : window.CONFIG) as BrowserSafeConfig
